<script lang="ts">
  import { resolve } from '$app/paths'
  import { helpPath } from '$lib/help'
  import NextIcon from '~icons/tabler/arrow-right'

  interface Props {
    post: { full_slug: string; title: string; teaser: string }
    supheading?: string
  }

  let { post, supheading = '' }: Props = $props()
</script>

<div class="reference">
  <a class="next" href={resolve(helpPath(post.full_slug))}>
    <div class="content">
      {#if supheading}
        <p class="@supheading +small">{supheading}</p>
      {/if}
      <h3 class="@heading +small">{post.title}</h3>
      <p class="teaser">
        {post.teaser}
      </p>
    </div>
    <div class="icon">
      <NextIcon />
    </div>
  </a>
</div>

<style lang="postcss">
  .reference {
    container-type: inline-size;
    margin-bottom: 1rem;
  }
  .\@supheading {
    color: var(--color-text-brand);
  }
  a {
    display: flex;
    align-items: center;
    gap: 3rem;
    border: 1px solid var(--color-border);
    border-radius: var(--radius-md);
    padding: 1rem;
    color: var(--color-text);

    @container (width < 26rem) {
      flex-direction: column;
      gap: 1rem;
    }

    &.next {
      grid-column: 2;
    }
    &:hover {
      background-color: var(--color-bg-surface);
    }
    .content {
      flex: 1;
      .teaser {
        color: var(--color-text-secondary);
        font-size: var(--scale-0);
      }
    }
    &:hover {
      .icon {
        translate: 0.5rem 0;
      }
    }
    .icon {
      transition: translate 0.2s ease;
      font-size: 1.5rem;
    }
  }
</style>
